import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function LoginPage({ onLogin }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await onLogin({ email, password });
    } catch (error) {
      alert(error.message || t('login.loginFailed'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <section className="welcome-wrap">
      <article className="welcome-card">
        <h2>{t('login.title')}</h2>
        <p>{t('login.subtitle')}</p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('login.email')}
            required
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('login.password')}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? t('login.loading') : t('login.submit')}
          </button>
        </form>
      </article>
    </section>
  );
}
